/*
 * This program is part of the OpenCms Rebrush Template.
 *
 * Copyright (c) Alkacon Software GmbH & Co. KG (http://www.alkacon.com)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// Module implemented using the "revealing module pattern", see
// https://addyosmani.com/resources/essentialjsdesignpatterns/book/#revealingmodulepatternjavascript
// https://www.christianheilmann.com/2007/08/22/again-with-the-module-pattern-reveal-something-to-the-world/
var RebrushNavigation = function(jQ) {

    "use strict";

    var m_fixedHeader = null;

    function resetSubMenus($topmenu, $submenu) {
        $topmenu.find(".dropdown-submenu").each(function(i) {
            var $this = jQ(this);
            if (!($submenu && jQ.contains(this, $submenu))) {
                $this.removeClass("open");
                $this.removeClass("open-left");
                $this.removeClass("open-right");
                $this.find(".dropdown-menu").first().css("right", "");
                $this.find(".dropdown-toggle").first().attr("aria-expanded", "false");
            }
        });
    }

    function setKeyboardClass(active) {
        if (active) {
            jQ(document.documentElement).addClass('ap-keyboard-nav');
        } else {
            jQ(document.documentElement).removeClass('ap-keyboard-nav');
        }
    }

    function toggleTopmenu($dropdown, open) {
        var isOpen = $dropdown.hasClass("open");
        if ((open && !isOpen) || (!open && isOpen)) {
            var $toggle = $dropdown.find(".dropdown-toggle").first();
            var $menu = $dropdown.find(".dropdown-menu").first();
            // for the top level we use the bootstrap native method
            $toggle.dropdown("toggle");
            resetSubMenus($dropdown);
            if ($menu.offset().left + $menu.outerWidth() > Rebrush.windowWidth()) {
                // this menu must open left
                $dropdown.addClass("open-left");
            } else {
                $dropdown.removeClass("open-left");
            }
        }
    }

    function toggleSubmenu($dropdown, event) {
        var $toggle = $dropdown.find(".dropdown-toggle").first();
        if (!$dropdown.hasClass("open")) {
            var $menu = $dropdown.find(".dropdown-menu").first();
            var openLeft = $dropdown.closest('.open-left').length > 0;
            var openRight = $dropdown.closest('.open-right').length > 0;
            resetSubMenus($dropdown.closest('.dropdown.ap-nav-header'), $toggle.get(0));
            // open the menu
            $dropdown.addClass("open");
            $toggle.attr("aria-expanded", "true");
            if (openRight || (openLeft && ($menu.offset().left - $menu.outerWidth() <= 0))) {
                // we have opened left to far, open to the right again
                openLeft = false;
                $dropdown.addClass("open-right");
            } else if (openLeft || ($menu.offset().left + $menu.outerWidth() > Rebrush.windowWidth())) {
                // this menu must open left, the right corner is outside window
                $dropdown.addClass("open-left");
                var $parent = $dropdown.parent();
                if ($parent.outerWidth() > Math.floor(parseFloat($parent.css("min-width")))) {
                    // parent is wider than min-width from CSS, adjust right position
                    $menu.css("right", $parent.outerWidth());
                }
            }
        } else if (event.type == "click") {
            $dropdown.removeClass("open");
            $toggle.attr("aria-expanded", "false");
        }
        event.preventDefault();
        event.stopPropagation();
    }


    // Nav bar
    function initNavBar() {
        // Show / hide top level menu on hover
        jQ('.dropdown.ap-nav-header').on('mouseenter mouseleave', function(e) {

            if (Rebrush.gridInfo().isDesktopNav()) {
                toggleTopmenu(jQ(this), e.type == "mouseenter");
            }
        });

        // Support for using a top level menu item for opening the menu AND direct linking
        jQ('.dropdown.ap-nav-header > .dropdown-toggle.nav-handle').on('keydown touchstart', function(e) {

            if (Rebrush.gridInfo().isDesktopNav() && !(e.type == "keydown" && e.which == 9)) {
                // setting the "open" class on the parent will trigger display:none on this element
                toggleTopmenu(jQ(this).parent(), true);
                e.preventDefault();
                e.stopPropagation();
            }
        });

        // Show sub-menu on hover
        jQ('.dropdown.ap-nav-header .dropdown-submenu').on('mouseenter', function(e) {

            if (Rebrush.gridInfo().isDesktopNav()) {
                toggleSubmenu(jQ(this), e);
            }
        });

        // Show sub-menu on click for mobile
        jQ('.dropdown.ap-nav-header .dropdown-submenu > .nav-trigger').on('click', function(e) {

            if (! Rebrush.gridInfo().isDesktopNav()) {
                toggleSubmenu(jQ(this).parent(), e);
            }
        });

        // Support for sub-menu click navigation (for keyboard users)
        jQ('.dropdown.ap-nav-header .dropdown-submenu .dropdown-toggle').on('keydown touchstart', function(e) {

            if (Rebrush.gridInfo().isDesktopNav() && !(e.type == "keydown" && e.which == 9)) {
                toggleSubmenu(jQ(this).parent(), e);
            }
        });
    }

    var navBarDynamicMobileLoaded = false;
    var navBarDynamicDesktopLoaded = false;
    var m_$navBarDynamicMobile = null;
    var m_$navBarDynamicDesktop = null;
    var m_$navBar = null;
    var m_navData = null;

    function updateWidth() {

        if (Rebrush.gridInfo().isDesktopNav() && navBarDynamicMobileLoaded) {
            loadDynamicNavigation();
        }
    }

    function loadDynamicNavigation() {

        if (DEBUG) console.info("loadDynamicNavigation(): Navigation should be displayed for " + Rebrush.gridInfo().navType());

        if (m_$navBar == null) {
            m_$navBar = jQ('ul.nav[data-nav]');
            m_navData = m_$navBar.data("nav");
        }

        if (Rebrush.gridInfo().isMobileNav()) {

            if (m_$navBar.length > 0) {

                var ajaxLink = "/system/modules/de.erzbistumkoeln.portal.rebrush/elements/nav-mobile-ajax.jsp?content="
                    + m_navData.content
                    + "&detailTitle=" + m_navData.detailTitle
                    + "&folderUri=" + m_navData.folderUri;

                if ((m_$navBarDynamicMobile == null) && !navBarDynamicMobileLoaded) {
                    navBarDynamicMobileLoaded = true;
                    navBarDynamicDesktopLoaded = false
                    jQ.get(ajaxLink, function(navHtml) {

                        var $navResult = jQ(navHtml);
                        var m_$navBarDynamicMobile = $navResult.filter("#navresult").find(".nav");

                        if (DEBUG) console.info("loadDynamicNavigation(): Mobile navigation loaded: " + (m_$navBarDynamicMobile.length > 0));

                        m_$navBar.replaceWith(m_$navBarDynamicMobile);
                        m_$navBar = m_$navBarDynamicMobile;
                        initNavBar();

                    }, "html");
                } else if (m_$navBarDynamicMobile != null) {

                    if (DEBUG) console.info("loadDynamicNavigation(): Mobile navigation reused");

                    navBarDynamicMobileLoaded = true;
                    navBarDynamicDesktopLoaded = false
                    m_$navBar.replaceWith(m_$navBarDynamicMobile);
                    m_$navBar = m_$navBarDynamicMobile;
                    initNavBar();
                } else {

                    if (DEBUG) console.info("loadDynamicNavigation(): Mobile navigation still active, no need to rebuild");
                }
            }

        } else {

            if (m_$navBar.length > 0) {

                var ajaxLink = "/system/modules/de.erzbistumkoeln.portal.rebrush/elements/nav-tree-ajax.jsp?content="
                    + m_navData.content
                    + "&folderUri=" + m_navData.folderUri;

                if ((m_$navBarDynamicDesktop == null) && !navBarDynamicDesktopLoaded) {
                    navBarDynamicDesktopLoaded = true;
                    navBarDynamicMobileLoaded = false;
                    jQ.get(ajaxLink, function(navHtml) {

                        var $navResult = jQ(navHtml);
                        var m_$navBarDynamicDesktop = $navResult.filter("#navresult").find(".nav");

                        if (DEBUG) console.info("loadDynamicNavigation(): Desktop navigation loaded: " + (m_$navBarDynamicDesktop.length > 0));

                        m_$navBar.replaceWith(m_$navBarDynamicDesktop);
                        m_$navBar = m_$navBarDynamicDesktop;
                        initNavBar();

                    }, "html");
                } else if (m_$navBarDynamicDesktop != null) {

                    if (DEBUG) console.info("loadDynamicNavigation(): Desktop navigation reused");
                    navBarDynamicDesktopLoaded = true;
                    navBarDynamicMobileLoaded = false;
                    m_$navBar.replaceWith(m_$navBarDynamicDesktop);
                    m_$navBar = m_$navBarDynamicDesktop;
                    initNavBar();
                } else {

                    if (DEBUG) console.info("loadDynamicNavigation(): Desktop navigation still active, no need to rebuild");
                }
            }
        }
    }


    // Elements in head navigation
    function initHeadNavigation() {

        var $navBar = jQ('ul.nav[data-nav]');

        if ($navBar.length <= 0) {
            // navigation loaded directly
            initNavBar();
        } else {
            // navigation loaded by Ajax
            if (DEBUG) console.info("initHeadNavigation(): Dynamic navigation is enabled");

            $navBar.on('mouseenter click keydown touchstart', function(e) {

                loadDynamicNavigation();
            });
        }

        // Add handler for elements that should not keep the focus
        jQ('[data-toggle], .blur-focus').on('mouseleave', function(e) {

            jQ(this).blur();
        });

        // Responsive navbar toggle button
        jQ('.head-toggle .nav-toggle').click(function() {
            jQ('.head-toggle .nav-toggle').toggleClass('active');
            jQ(document.documentElement).toggleClass('active-nav');
            loadDynamicNavigation();
        });

        // If user presses tab, add marker class to document body to enable focus highlighting
        jQ(document.documentElement).on('keydown', function(e) {

            if (e.which == 9) {
                setKeyboardClass(true);
            }
        });

        // If the mouse is moved, remove focus highlight marker class
        jQ(document.documentElement).on('mousemove', function(e) {

            setKeyboardClass(false);
        });
    }


    // Clickme-Showme effect sections
    function initClickToShow() {

        var $clickSections = jQ('.click-to-show');
        if (DEBUG) console.info(".click-to-show elements found: " + $clickSections.length);
        $clickSections.each(function() {

            var $element = jQ(this);
            var $clickme = $element.find('> .clickme');
            var $showme  = $element.find('> .showme');

            $clickme.click(function() {
                $clickme.toggleClass("closed");
                $showme.toggleClass("closed");
            });
        });
    }


    var m_$anchor = null;
    // Smooth scrolling to anchor links
    function scrollToAnchor($anchor) {
        if ($anchor.length) {
            m_$anchor = $anchor;
            debScrollToAnchor();
            m_$anchor = null;
        }
    }

    var debScrollToAnchor = Rebrush.debounce(function() {
        if (m_$anchor.length) {
            var targetTop = m_$anchor.offset().top;
            if (DEBUG) console.info("scrollToAnchor(#" + m_$anchor.attr('id') + ") position:" + targetTop);
            var page = $("html, body");
            // see: https://stackoverflow.com/questions/18445590/jquery-animate-stop-scrolling-when-user-scrolls-manually
            page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
                page.stop();
            });
            page.animate({ scrollTop: Math.ceil(targetTop - Rebrush.toolbarHeight()) }, 1000, function(){
                page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
            });
        }
    }, 500, true);


    // add click handler and adjust position on initial page load
    function initSmoothScrolling() {

        // attach click handler to anchor links on the page
        jQ('a[href*="#"]:not([href="#"]):not([data-toggle]):not([data-slide])').click(function() {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var $target = jQ(this.hash);
                if ($target.length) {
                    jQ(this).blur();
                    scrollToAnchor($target);
                    return false;
                }
            }
        });

        // for initial page load, make sure we adjust scroll position for fixed header and OpenCms toolbar
        if (location.hash.length) {
            if (DEBUG) console.info("Initial anchor (location.hash): " + location.hash);
            scrollToAnchor(jQ(location.hash));
        }
    }

    // apply "external" class to all a href links
    function initExternalLinks() {

        var $aHrefs = jQ('.ap-section a');
        if (DEBUG) console.info("a elements found in .ap-sections: " + $aHrefs.length);
        if (DEBUG) console.info("location.hostname is: " + location.hostname);
        try {
            if (! Rebrush.isEditMode()) {
                $aHrefs.each(function() {

                    var $element = jQ(this);
                    var hostname = $element.prop("hostname");
                    if (hostname && hostname !== location.hostname) {
                        $element.addClass("external");
                    }
                });
            } else {
                if (DEBUG) console.info("skipped external a element extension because of edit mode");
            }
        } catch (err) {
            // required otherwise IE may prodice an error and stop execution
            console.info("initExternalLinks() Error " + err);
        }
    }

    // Breadcrumb positioning
    function initBreadcrumbs() {

        if (! Rebrush.isEditMode()) {
            var $breadcrumbs = jQ('#breadcrumb');
            var $breadcrumbData = jQ('#breadcrumb-data');
            if ($breadcrumbs.length && $breadcrumbData.length) {
                $breadcrumbs.append($breadcrumbData);
            }
        }
    }

    // Clean up empty containers
    function cleanupContainers() {

        if (! Rebrush.isEditMode()) {
            jQ('#portal-right-col-container:empty').remove();
            var $gridElements = jQ('#page-side');
            $gridElements.each(function() {
                var $element = jQ(this);
                if (jQ.trim($element.text()) == "") {
                    if ($element.attr('id') == 'page-side') {
                        $element.remove();
                        // jQ("#page-content").removeClass('col-md-9');
                    }
                }
            });
        }
    }

    function init() {

        if (DEBUG) console.info("RebrushNavigation.init()");

        initHeadNavigation();
        cleanupContainers();
        initBreadcrumbs();
        initClickToShow();
        initSmoothScrolling();
        initExternalLinks();
    }

    // public available functions
    return {
        init: init,
        scrollToAnchor: scrollToAnchor,
        updateWidth: updateWidth
    }

}(jQuery);

